<template>
  <div class="view-tools">
    <page-header
      title="Ferramentas"
      subtitle="Configure ferramentas de acordo com o estágio atual do seu negócio"
    />
    <page-container>
      <div v-for="(scope, i) in toolList" :key="i">
        <div class="row" v-if="scope.options.length">
          <router-link
            v-for="(tool, i) in scope.options"
            :key="i"
            :to="{ name: tool.route }"
            class="col-xl-3 col-lg-4 text-decoration-none"
          >
            <feature-card
              :icon="tool.icon"
              :title="tool.name"
              :color="scope.color"
              :subtitle="tool.description"
            />
          </router-link>
        </div>
        <hr
          v-if="i + 1 !== toolList.length && scope.options.length"
          class="mt-5 mx-3 mb-0 border-neutral-100"
        />
      </div>
    </page-container>
  </div>
</template>

<script>
import { TOOLS_LIST } from "@/constants/tools.js";

export default {
  computed: {
    toolList() {
      return TOOLS_LIST.map(tool => {
        tool.options = tool.options.filter(opt => this.permitted(opt));
        return tool;
      });
    }
  },
  methods: {
    permitted(tool) {
      return (
        !tool.permission || this.$permissions.hasPermission(tool.permission)
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.view-tools {
  hr {
    margin: 8px 0 32px;
  }
}
</style>
